import gql from 'graphql-tag'

export const getDesignFolders = gql`
  query getDesignFolders {
   folders: getDesignFolders {
      shortId: short_id
      name
      color
      items
      icon
      createdAt: created_at
      updatedAt: updated_at
    }
  }
`


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/components/MyLocker/FoldersView/data.ts